import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar'; 
import Header from '../components/Header'; 
import '../assets/css/styles.min.css';
import axios from 'axios';
import Swal from 'sweetalert2';

// Configure axios defaults
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Accept'] = 'application/json';
// Add any auth tokens if needed
// axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [newCategoryName, setNewCategoryName] = useState('');
  const [newCategoryIcon, setNewCategoryIcon] = useState('code');
  const [editCategory, setEditCategory] = useState(null);
  const [viewCategory, setViewCategory] = useState(null);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  // States for search and pagination
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Programming, AI, and design-related icons
  const iconOptions = [
    // Programming Icons
    { value: 'code', label: 'Code', icon: 'fas fa-code' },
    { value: 'laptop-code', label: 'Laptop Code', icon: 'fas fa-laptop-code' },
    { value: 'terminal', label: 'Terminal', icon: 'fas fa-terminal' },
    { value: 'bug', label: 'Bug', icon: 'fas fa-bug' },
    { value: 'code-branch', label: 'Code Branch', icon: 'fas fa-code-branch' },
    { value: 'git-alt', label: 'Git', icon: 'fab fa-git-alt' },
    { value: 'js', label: 'JavaScript', icon: 'fab fa-js-square' },
    { value: 'html5', label: 'HTML5', icon: 'fab fa-html5' },
    { value: 'css3', label: 'CSS3', icon: 'fab fa-css3-alt' },
    { value: 'php', label: 'PHP', icon: 'fab fa-php' },
    { value: 'python', label: 'Python', icon: 'fab fa-python' },
    { value: 'java', label: 'Java', icon: 'fab fa-java' },
    { value: 'react', label: 'React', icon: 'fab fa-react' },
    { value: 'node-js', label: 'Node.js', icon: 'fab fa-node-js' },
    { value: 'npm', label: 'NPM', icon: 'fab fa-npm' },
    { value: 'github', label: 'GitHub', icon: 'fab fa-github' },
    { value: 'gitlab', label: 'GitLab', icon: 'fab fa-gitlab' },
    { value: 'stack-overflow', label: 'Stack Overflow', icon: 'fab fa-stack-overflow' },
    
    // AI and Data Science Icons
    { value: 'brain', label: 'AI Brain', icon: 'fas fa-brain' },
    { value: 'robot', label: 'Robot', icon: 'fas fa-robot' },
    { value: 'microchip', label: 'Microchip', icon: 'fas fa-microchip' },
    { value: 'server', label: 'Server', icon: 'fas fa-server' },
    { value: 'database', label: 'Database', icon: 'fas fa-database' },
    { value: 'chart-bar', label: 'Chart Bar', icon: 'fas fa-chart-bar' },
    { value: 'chart-line', label: 'Chart Line', icon: 'fas fa-chart-line' },
    { value: 'chart-pie', label: 'Chart Pie', icon: 'fas fa-chart-pie' },
    { value: 'chart-area', label: 'Chart Area', icon: 'fas fa-chart-area' },
    { value: 'project-diagram', label: 'Project Diagram', icon: 'fas fa-project-diagram' },
    { value: 'network-wired', label: 'Network', icon: 'fas fa-network-wired' },
    { value: 'sitemap', label: 'Sitemap', icon: 'fas fa-sitemap' },
    { value: 'analytics', label: 'Analytics', icon: 'fas fa-analytics' },
    { value: 'cogs', label: 'Cogs', icon: 'fas fa-cogs' },
    { value: 'atom', label: 'Atom', icon: 'fas fa-atom' },
    { value: 'cloud', label: 'Cloud', icon: 'fas fa-cloud' },
    { value: 'cloud-upload-alt', label: 'Cloud Upload', icon: 'fas fa-cloud-upload-alt' },
    { value: 'cloud-download-alt', label: 'Cloud Download', icon: 'fas fa-cloud-download-alt' },
    
    // Design Icons
    { value: 'pencil-ruler', label: 'Design Tools', icon: 'fas fa-pencil-ruler' },
    { value: 'palette', label: 'Palette', icon: 'fas fa-palette' },
    { value: 'paint-brush', label: 'Paint Brush', icon: 'fas fa-paint-brush' },
    { value: 'fill-drip', label: 'Fill', icon: 'fas fa-fill-drip' },
    { value: 'bezier-curve', label: 'Bezier Curve', icon: 'fas fa-bezier-curve' },
    { value: 'vector-square', label: 'Vector', icon: 'fas fa-vector-square' },
    { value: 'pen-fancy', label: 'Pen', icon: 'fas fa-pen-fancy' },
    { value: 'pen-nib', label: 'Pen Nib', icon: 'fas fa-pen-nib' },
    { value: 'layer-group', label: 'Layers', icon: 'fas fa-layer-group' },
    { value: 'object-group', label: 'Object Group', icon: 'fas fa-object-group' },
    { value: 'object-ungroup', label: 'Object Ungroup', icon: 'fas fa-object-ungroup' },
    { value: 'ruler-combined', label: 'Ruler', icon: 'fas fa-ruler-combined' },
    { value: 'crop', label: 'Crop', icon: 'fas fa-crop' },
    { value: 'swatchbook', label: 'Swatchbook', icon: 'fas fa-swatchbook' },
    { value: 'drafting-compass', label: 'Compass', icon: 'fas fa-drafting-compass' },
    { value: 'photo-video', label: 'Photo Video', icon: 'fas fa-photo-video' },
    { value: 'compress', label: 'Compress', icon: 'fas fa-compress' },
    { value: 'expand', label: 'Expand', icon: 'fas fa-expand' },
    
    // UI/UX Icons
    { value: 'desktop', label: 'Desktop', icon: 'fas fa-desktop' },
    { value: 'mobile-alt', label: 'Mobile', icon: 'fas fa-mobile-alt' },
    { value: 'tablet-alt', label: 'Tablet', icon: 'fas fa-tablet-alt' },
    { value: 'laptop', label: 'Laptop', icon: 'fas fa-laptop' },
    { value: 'tv', label: 'TV/Monitor', icon: 'fas fa-tv' },
    { value: 'window-restore', label: 'Window', icon: 'fas fa-window-restore' },
    { value: 'window-maximize', label: 'Window Max', icon: 'fas fa-window-maximize' },
    { value: 'sliders-h', label: 'Sliders', icon: 'fas fa-sliders-h' },
    { value: 'tachometer-alt', label: 'Dashboard', icon: 'fas fa-tachometer-alt' },
    { value: 'puzzle-piece', label: 'Puzzle', icon: 'fas fa-puzzle-piece' }
  ];

  // Function to fetch categories
  const fetchCategories = () => {
    setLoading(true);
    setError(null);
    
    axios.get('https://api.codecircle.co/api/categories')
      .then(response => {
        if (response.data) {
          setCategories(response.data);
        } else {
          throw new Error('Invalid data format received');
        }
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching categories:', error);
        setError('Failed to load categories. Please try again later.');
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // Filter categories based on search
  const filteredCategories = categories.filter(category => 
    category.name?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentCategories = filteredCategories.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredCategories.length / itemsPerPage);

  const handleAddCategory = () => {
    if (!newCategoryName.trim()) {
      Swal.fire('Error', 'Category name cannot be empty', 'error');
      return;
    }
    
    setLoading(true);
    setError(null);
    
    const newCategory = { 
      name: newCategoryName,
      icon: newCategoryIcon
    };
    
    axios.post('https://api.codecircle.co/api/categories', newCategory)
      .then(response => {
        if (response.data) {
          // Fetch all categories again to ensure we have the latest data
          fetchCategories();
          setNewCategoryName('');
          setNewCategoryIcon('code');
          setIsAddModalOpen(false);
          Swal.fire('Success!', 'Category added successfully.', 'success');
        } else {
          throw new Error('Invalid response format');
        }
      })
      .catch(error => {
        console.error('Error adding category:', error);
        Swal.fire('Error', 'Failed to add category. Please try again later.', 'error');
        setError('Failed to add category. Please try again later.');
        setLoading(false);
      });
  };

  const handleEditCategory = (category) => {
    // Create a deep copy to prevent direct state mutation
    setEditCategory({...category});
  };

  const handleUpdateCategory = () => {
    if (!editCategory || !editCategory.name.trim()) {
      Swal.fire('Error', 'Category name cannot be empty', 'error');
      return;
    }
    
    setLoading(true);
    setError(null);
    
    axios.put(`https://api.codecircle.co/api/categories/${editCategory.id}`, { 
      name: editCategory.name,
      icon: editCategory.icon 
    })
      .then(response => {
        if (response.data) {
          // Fetch all categories again to ensure we have the latest data
          fetchCategories();
          setEditCategory(null);
          Swal.fire('Success!', 'Category updated successfully.', 'success');
        } else {
          throw new Error('Invalid response format');
        }
      })
      .catch(error => {
        console.error('Error updating category:', error);
        Swal.fire('Error', 'Failed to update category. Please try again later.', 'error');
        setError('Failed to update category. Please try again later.');
        setLoading(false);
      });
  };

  // Changed to soft delete
  // Changed from PATCH to DELETE to match your API
const handleDeleteCategory = (id) => {
  Swal.fire({
    title: 'Are you sure?',
    text: "This will delete the category permanently.",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!'
  }).then((result) => {
    if (result.isConfirmed) {
      setLoading(true);
      setError(null);
      
      // Updated to use DELETE method to match your API
      axios.delete(`https://api.codecircle.co/api/categories/${id}`)
        .then(response => {
          // Fetch all categories again to ensure we have the latest data
          fetchCategories();
          Swal.fire('Deleted!', 'Your category has been deleted.', 'success');
        })
        .catch(error => {
          console.error('Error deleting category:', error);
          Swal.fire('Error', 'Failed to delete category. Please try again later.', 'error');
          setError('Failed to delete category. Please try again later.');
          setLoading(false);
        });
    }
  });
};

  return (
    <div className="page-wrapper" id="main-wrapper" data-layout="vertical" data-navbarbg="skin6" data-sidebartype="full" data-sidebar-position="fixed" data-header-position="fixed">
      <Sidebar />
      <div className="body-wrapper">
        <Header /> 
        <div className="container-fluid">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title fw-semibold mb-4">Categories</h5>

                {error && <div className="alert alert-danger">{error}</div>}

                {/* Search and Controls Section */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="d-flex gap-3 align-items-center">
                    <div className="search-box">
                      <div className="input-group" style={{ width: '250px' }}>
                        <span className="input-group-text border-primary bg-primary">
                          <i className="fas fa-search text-white"></i>
                        </span>
                        <input
                          type="text"
                          className="form-control border-primary"
                          placeholder="Search categories..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </div>
                    </div>
                    <select
                      className="form-select border-primary"
                      style={{ width: '100px' }}
                      value={itemsPerPage}
                      onChange={(e) => {
                        setItemsPerPage(Number(e.target.value));
                        setCurrentPage(1);
                      }}
                    >
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                    </select>
                  </div>
                  <button 
                    className="btn btn-primary" 
                    style={{ borderRadius: '15px', padding: '8px 16px', fontSize: '14px' }} 
                    onClick={() => setIsAddModalOpen(true)}
                  >
                    Add Category
                  </button>
                </div>

                {loading ? (
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                ) : (
                  <>
                    <div className="table-responsive">
                      <table className="table text-nowrap align-middle mb-0">
                        <thead>
                          <tr className="border-2 border-bottom border-primary border-0">
                            <th scope="col">ID</th>
                            <th scope="col">Icon</th>
                            <th scope="col">Name</th>
                            <th scope="col" className="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentCategories.length > 0 ? (
                            currentCategories.map(category => (
                              <tr key={category.id}>
                                <th scope="row">{category.id}</th>
                                <td>
                                  <i className={`${iconOptions.find(opt => opt.value === category.icon)?.icon || 'fas fa-code'} fa-lg`}></i>
                                </td>
                                <td>{category.name}</td>
                                <td className="text-center">
                                  <i className="fas fa-eye text-info" onClick={() => setViewCategory(category)} style={{ cursor: 'pointer' }}></i>
                                  <i className="fas fa-edit text-primary" onClick={() => handleEditCategory(category)} style={{ marginLeft: '10px', cursor: 'pointer' }}></i>
                                  <i className="fas fa-trash text-danger" onClick={() => handleDeleteCategory(category.id)} style={{ marginLeft: '10px', cursor: 'pointer' }}></i>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center">No categories found</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    {/* Pagination Controls */}
                    {filteredCategories.length > 0 && (
                      <div className="d-flex justify-content-between align-items-center mt-3">
                        <div className="text-muted fs-13">
                          Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredCategories.length)} of {filteredCategories.length} entries
                        </div>
                        <nav>
                          <ul className="pagination pagination-primary mb-0">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                              <button className="page-link" 
                                      onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}>
                                <i className="fas fa-chevron-left"></i>
                              </button>
                            </li>
                            {[...Array(totalPages)].map((_, i) => (
                              <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                                <button className="page-link" 
                                        onClick={() => setCurrentPage(i + 1)}>
                                  {i + 1}
                                </button>
                              </li>
                            ))}
                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                              <button className="page-link" 
                                      onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}>
                                <i className="fas fa-chevron-right"></i>
                              </button>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Add Modal */}
        {isAddModalOpen && ( 
          <div className="modal show" style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Add Category</h5>
                  <button type="button" className="btn-close" onClick={() => setIsAddModalOpen(false)}></button>
                </div>
                <div className="modal-body">
                  <form onSubmit={(e) => {
                    e.preventDefault();
                    handleAddCategory();
                  }}>
                    <div className="mb-3">
                      <label htmlFor="categoryName" className="form-label">Category Name</label>
                      <input 
                        type="text" 
                        className="form-control" 
                        id="categoryName"
                        value={newCategoryName} 
                        onChange={(e) => setNewCategoryName(e.target.value)} 
                        required 
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="categoryIcon" className="form-label">Category Icon</label>
                      <div className="d-flex flex-wrap gap-2 mb-2" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                        {iconOptions.map((icon) => (
                          <div 
                            key={icon.value}
                            className={`icon-option p-2 border rounded ${newCategoryIcon === icon.value ? 'border-primary bg-light' : ''}`}
                            onClick={() => setNewCategoryIcon(icon.value)}
                            style={{ cursor: 'pointer', width: '60px', textAlign: 'center' }}
                            title={icon.label}
                          >
                            <i className={`${icon.icon} fa-lg`}></i>
                          </div>
                        ))}
                      </div>
                      <div className="mt-2">
                        <span>Selected Icon: </span>
                        <i className={`${iconOptions.find(opt => opt.value === newCategoryIcon)?.icon || 'fas fa-code'} fa-lg ms-2`}></i>
                        <span className="ms-2">{iconOptions.find(opt => opt.value === newCategoryIcon)?.label || 'Code'}</span>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setIsAddModalOpen(false)}>Close</button>
                  <button type="button" className="btn btn-primary" onClick={handleAddCategory}>Save</button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Edit Modal */}
        {editCategory && (
          <div className="modal show" style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Edit Category</h5>
                  <button type="button" className="btn-close" onClick={() => setEditCategory(null)}></button>
                </div>
                <div className="modal-body">
                  <form onSubmit={(e) => {
                    e.preventDefault();
                    handleUpdateCategory();
                  }}>
                    <input type="hidden" value={editCategory.id} />
                    <div className="mb-3">
                      <label htmlFor="editCategoryName" className="form-label">Category Name</label>
                      <input 
                        type="text" 
                        className="form-control" 
                        id="editCategoryName"
                        value={editCategory.name} 
                        onChange={(e) => setEditCategory({ ...editCategory, name: e.target.value })} 
                        required 
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="categoryIcon" className="form-label">Category Icon</label>
                      <div className="d-flex flex-wrap gap-2 mb-2" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                        {iconOptions.map((icon) => (
                          <div 
                            key={icon.value}
                            className={`icon-option p-2 border rounded ${editCategory.icon === icon.value ? 'border-primary bg-light' : ''}`}
                            onClick={() => setEditCategory({ ...editCategory, icon: icon.value })}
                            style={{ cursor: 'pointer', width: '60px', textAlign: 'center' }}
                            title={icon.label}
                          >
                            <i className={`${icon.icon} fa-lg`}></i>
                          </div>
                        ))}
                      </div>
                      <div className="mt-2">
                        <span>Selected Icon: </span>
                        <i className={`${iconOptions.find(opt => opt.value === editCategory.icon)?.icon || 'fas fa-code'} fa-lg ms-2`}></i>
                        <span className="ms-2">{iconOptions.find(opt => opt.value === editCategory.icon)?.label || 'Code'}</span>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setEditCategory(null)}>Close</button>
                  <button type="button" className="btn btn-primary" onClick={handleUpdateCategory}>Update</button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* View Modal */}
        {viewCategory && (
          <div className="modal show" style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Category Details</h5>
                  <button type="button" className="btn-close" onClick={() => setViewCategory(null)}></button>
                </div>
                <div className="modal-body">
                  <div className="text-center mb-3">
                    <i className={`${iconOptions.find(opt => opt.value === viewCategory.icon)?.icon || 'fas fa-code'} fa-3x`}></i>
                    <p className="mt-2">{iconOptions.find(opt => opt.value === viewCategory.icon)?.label || 'Code'}</p>
                  </div>
                  <p><strong>Category ID:</strong> <span>{viewCategory.id}</span></p>
                  <p><strong>Name:</strong> <span>{viewCategory.name}</span></p>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setViewCategory(null)}>Close</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Categories;